import { Project } from '../Portfolio';

const backendProjects: Project[] = [
  {
    id: 'followup-automation',
    title: 'portfolio.backend.followup-backend.title',
    description: 'portfolio.backend.followup-backend.description',
    technologies: [
      'C#',
      'ASP.NET Core',
      'Entity Framework Core',
      'MS-SQL',
      'Json Web Tokens',
      'Autofac',
      'AutoMapper',
      'Trello',
      'SSMS',
      'Postman'
    ],
    picturesUris: [
      'https://i.imgur.com/yWNkN6W.png',
      'https://i.imgur.com/DC4JAgg.png',
      'https://i.imgur.com/A1AA1Vf.png',
      'https://i.imgur.com/PW0TYrU.png'
    ],
    githubLink: 'https://github.com/MiloszKowalski/followup-backend'
  }
]

export default backendProjects;